import { useState } from 'react';
import firebase from 'firebase/compat/app';
import { TRANSLATIONS } from '../config/translations';

const auth = firebase.auth();
const db = firebase.firestore();

export function LoginPage({ language }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const t = TRANSLATIONS[language];

  const handleMicrosoftLogin = async () => {
    setLoading(true);
    setError('');

    try {
      const provider = new firebase.auth.OAuthProvider('microsoft.com');

      provider.setCustomParameters({
        tenant: '834c6fa5-5a7e-4e6a-9abf-4f9166f9e65d' // Ihre Tenant ID
      });

      provider.addScope('email');
      provider.addScope('profile');

      const result = await auth.signInWithPopup(provider);

      // Check if user profile exists
      const userDoc = await db.collection('users').doc(result.user.uid).get();

      if (!userDoc.exists) {
        try {
          await db.collection('users').doc(result.user.uid).set({
            email: result.user.email,
            displayName: result.user.displayName || result.user.email?.split('@')[0] || 'Microsoft User',
            role: 'user',
            active: true,
            createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            loginMethod: 'microsoft',
            photoURL: result.user.photoURL || null,
            microsoftId: result.user.uid
          });
        } catch (createError) {
          // console statement removed for production

          // Logout user if profile creation fails
          await auth.signOut();
          throw new Error('Fehler beim Erstellen des Benutzerprofils. Bitte kontaktieren Sie einen Administrator.');
        }
      }

      // Success! User will be redirected by App component

    } catch (err) {
      // console statement removed for production

      if (err.code === 'auth/popup-closed-by-user') {
        setError('Login-Fenster wurde geschlossen');
      } else if (err.code === 'auth/popup-blocked') {
        setError('Popup wurde blockiert. Bitte erlauben Sie Popups für diese Seite.');
      } else if (err.code === 'permission-denied') {
        setError('Keine Berechtigung zum Erstellen des Benutzerprofils. Bitte kontaktieren Sie einen Administrator.');
      } else {
        setError(err.message || 'Fehler beim Microsoft Login');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <h1>QualiMed Swiss</h1>
          <p>Built for AM Physio</p>
        </div>

        {error && (
          <div className="error-message">{error}</div>
        )}

        {/* Microsoft Login */}
        <button
          type="button"
          className="microsoft-login-btn"
          onClick={handleMicrosoftLogin}
          disabled={loading}
        >
          <svg className="microsoft-icon" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="1" y="1" width="9" height="9" fill="#f25022"/>
            <rect x="1" y="11" width="9" height="9" fill="#00a4ef"/>
            <rect x="11" y="1" width="9" height="9" fill="#7fba00"/>
            <rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
          </svg>
          {loading ? 'Lädt...' : 'Mit Microsoft anmelden'}
        </button>
      </div>
    </div>
  );
}
